import { render } from "./UpdateProjectModal.vue?vue&type=template&id=0ca346e6&scoped=true&ts=true"
import script from "./UpdateProjectModal.vue?vue&type=script&lang=ts"
export * from "./UpdateProjectModal.vue?vue&type=script&lang=ts"

import "./UpdateProjectModal.vue?vue&type=style&index=0&id=0ca346e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca346e6"]])

export default __exports__